/**
 * Initializes common scripts used throughout the site.
 *
 * This script imports and initializes various functionalities such as:
 * - Accessibility triggers
 * - Menu toggle
 * - Form validation
 * - Phone number masking
 * - Selection handling
 * - Tooltips
 * - Alerts
 *
 * Note: If a script is only used on a specific page, consider adding it to the page-specific script file.
 */

// import 'bootstrap';

import { initMenuToggle } from "./common-scripts/menuToggle.js";
import { initFormValidation } from "./common-scripts/formValidation.js";
import { initPhoneMasking } from "./common-scripts/phoneMasking.js";
import { initSelectionHandler } from "./common-scripts/selectionHandler.js";
import { initTooltips } from "./common-scripts/tooltips.js";
import { initAlerts } from "./common-scripts/alertHandler.js";
import { initAccessibilityTrigger } from "./common-scripts/accessibilityHandler.js";
import { initDropdown } from "./common-scripts/navbarDropdown.js";

(function ($) {
  $(function () {
    initAccessibilityTrigger();
    initMenuToggle();
    initFormValidation();
    initPhoneMasking();
    initSelectionHandler();
    initTooltips();
    initAlerts();
    initDropdown();
  });
})(jQuery, window, document);

export {
  initAccessibilityTrigger,
  initMenuToggle,
  initFormValidation,
  initPhoneMasking,
  initDropdown,
  initSelectionHandler,
  initTooltips,
  initAlerts,
};
